import { appCode } from '@/common/consts';


// use this approach to split the code of a component, and bundle it as a separate chunk that is loaded lazily
const TwitterConnector = r => require.ensure([], () => r(require('@/components/twitterConnector/TwitterConnector')), 'TwitterConnector');
const TwitterAuthorized = r => require.ensure([], () => r(require('@/components/twitterConnector/TwitterAuthorized')), 'TwitterAuthorized');
const InstagramConnector = r => require.ensure([], () => r(require('@/components/instagramConnector/InstagramConnector')), 'InstagramConnector');
const FacebookConnector = r => require.ensure([], () => r(require('@/components/facebookConnector/FacebookConnector')), 'FacebookConnector');


export default [
  {
    path: `/${appCode}/twitterConnector`,
    alias: `/${appCode}`,
    name: `${appCode}:twitterConnector`,
    components: { [appCode]: TwitterConnector },
  },
  {
    path: `/${appCode}/authorized`,
    name: `${appCode}:authorized`,
    components: { [appCode]: TwitterAuthorized },
  },
  {
    path: `/${appCode}/instagramConnector`,
    name: `${appCode}:instagramConnector`,
    components: { [appCode]: InstagramConnector },
  },
  {
    path: `/${appCode}/facebookConnector`,
    name: `${appCode}:facebookConnector`,
    components: { [appCode]: FacebookConnector },
  },
];

